import { c as _c } from "react/compiler-runtime";
import { postHostedIdentifySessionKbaMutation } from '@onefootprint/fetch-hosted';
import type { IdentifyRequirementLogin } from '@onefootprint/request-types';
import { Button, Form, PageShell } from '@onefootprint/ui';
import { useMutation } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { isSessionExpired } from '@/idv2/features/identify/handle-session-expired';
import { renderScrubbedText } from '@/idv2/features/identify/render-scrubbed-text';
import { useVaultErrorMessage } from '@/idv2/features/identify/use-vault-error-message';
export type PhoneKbaChallengeProps = {
  loginRequirement: IdentifyRequirementLogin;
  onboardingSessionToken: string;
  defaultPhone?: string;
  onSuccess: () => void;
  onError?: (error: unknown) => void;
  headerIcon?: ReactNode;
};
type PhoneKbaFormData = {
  phone: string;
};
export const PhoneKbaChallenge = t0 => {
  const $ = _c(57);
  const {
    loginRequirement,
    onboardingSessionToken,
    defaultPhone,
    onSuccess,
    onError,
    headerIcon
  } = t0;
  const {
    t,
    i18n
  } = useTranslation("idv2");
  const locale = i18n.language === "es" ? "es-MX" : "en-US";
  const getVaultErrorMessage = useVaultErrorMessage();
  let t1;
  let t2;
  if ($[0] !== onboardingSessionToken) {
    const headers = {
      "X-Fp-Authorization": onboardingSessionToken
    };
    t1 = useMutation;
    t2 = postHostedIdentifySessionKbaMutation({
      headers
    });
    $[0] = onboardingSessionToken;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  const mutation = t1(t2);
  const t3 = defaultPhone ?? "";
  let t4;
  if ($[3] !== t3) {
    t4 = {
      defaultValues: {
        phone: t3
      }
    };
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const methods = useForm(t4);
  const t5 = loginRequirement.user?.scrubbedPhone ?? "";
  let T0;
  let handleSubmit;
  let t6;
  let t7;
  let t8;
  if ($[5] !== getVaultErrorMessage || $[6] !== headerIcon || $[7] !== methods || $[8] !== mutation || $[9] !== onError || $[10] !== onSuccess || $[11] !== t || $[12] !== t5) {
    const lastFourDigits = t5.slice(-4).replace(/\*/g, "\u2022");
    let t9;
    if ($[18] !== getVaultErrorMessage || $[19] !== methods || $[20] !== mutation || $[21] !== onError || $[22] !== onSuccess) {
      t9 = async data => {
        ;
        try {
          await mutation.mutateAsync({
            body: {
              "id.phone_number": data.phone
            }
          });
          onSuccess();
        } catch (t10) {
          const error = t10;
          if (isSessionExpired(error)) {
            onError?.(error);
            return;
          }
          const message = getVaultErrorMessage(error, "id.phone_number");
          if (message) {
            methods.setError("phone", {
              message
            });
          }
        }
      };
      $[18] = getVaultErrorMessage;
      $[19] = methods;
      $[20] = mutation;
      $[21] = onError;
      $[22] = onSuccess;
      $[23] = t9;
    } else {
      t9 = $[23];
    }
    handleSubmit = t9;
    T0 = PageShell;
    t6 = headerIcon;
    if ($[24] !== t) {
      t7 = t(_temp);
      $[24] = t;
      $[25] = t7;
    } else {
      t7 = $[25];
    }
    t8 = renderScrubbedText(t(_temp2, {
      digits: lastFourDigits
    }));
    $[5] = getVaultErrorMessage;
    $[6] = headerIcon;
    $[7] = methods;
    $[8] = mutation;
    $[9] = onError;
    $[10] = onSuccess;
    $[11] = t;
    $[12] = t5;
    $[13] = T0;
    $[14] = handleSubmit;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    T0 = $[13];
    handleSubmit = $[14];
    t6 = $[15];
    t7 = $[16];
    t8 = $[17];
  }
  let t9;
  if ($[26] !== handleSubmit || $[27] !== methods) {
    t9 = methods.handleSubmit(handleSubmit);
    $[26] = handleSubmit;
    $[27] = methods;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== t) {
    t10 = t(_temp3);
    $[29] = t;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t) {
    t11 = t(_temp4);
    $[31] = t;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t11) {
    t12 = {
      required: t11
    };
    $[33] = t11;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== locale || $[36] !== t10 || $[37] !== t12) {
    t13 = <Form.Tel label={t10} name="phone" locale={locale} rules={t12} />;
    $[35] = locale;
    $[36] = t10;
    $[37] = t12;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  const t14 = mutation.isPending;
  const t15 = mutation.isPending;
  let t16;
  if ($[39] !== t) {
    t16 = t(_temp5);
    $[39] = t;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== mutation.isPending || $[42] !== t16) {
    t17 = <Button type="submit" variant="primary" fullWidth={true} size="large" loading={t14} disabled={t15}>{t16}</Button>;
    $[41] = mutation.isPending;
    $[42] = t16;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== t13 || $[45] !== t17 || $[46] !== t9) {
    t18 = <form onSubmit={t9} className="flex flex-col gap-4 w-full">{t13}{t17}</form>;
    $[44] = t13;
    $[45] = t17;
    $[46] = t9;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== methods || $[49] !== t18) {
    t19 = <FormProvider {...methods}>{t18}</FormProvider>;
    $[48] = methods;
    $[49] = t18;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  let t20;
  if ($[51] !== T0 || $[52] !== t19 || $[53] !== t6 || $[54] !== t7 || $[55] !== t8) {
    t20 = <T0 headerIcon={t6} title={t7} subtitle={t8}>{t19}</T0>;
    $[51] = T0;
    $[52] = t19;
    $[53] = t6;
    $[54] = t7;
    $[55] = t8;
    $[56] = t20;
  } else {
    t20 = $[56];
  }
  return t20;
};
function _temp($) {
  return $.identify.kba.title;
}
function _temp2($_0) {
  return $_0.identify.kba.subtitle;
}
function _temp3($_1) {
  return $_1.identify.phone.label;
}
function _temp4($_2) {
  return $_2.identify.phone.requiredError;
}
function _temp5($_3) {
  return $_3.identify.phone.continue;
}